import { render, staticRenderFns } from "./ModalGrossingResponsibleList.vue?vue&type=template&id=21a15134&"
import script from "./ModalGrossingResponsibleList.vue?vue&type=script&lang=js&"
export * from "./ModalGrossingResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./ModalGrossingResponsibleList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports